import axios from 'axios';

const BACKEND_BASE_URL = process.env.REACT_APP_BACKEND_BASE_URL;
const TXN_API = axios.create({ baseURL: `${BACKEND_BASE_URL}/api/v1/user` });


// Request interceptor to add authorization and accept headers
TXN_API.interceptors.request.use(
  (req) => {
    const userToken = localStorage.getItem('token');
    if (userToken) {
        req.headers.Authorization = `Bearer ${userToken}`;
        req.headers.Accept = 'application/json';
    }
    if (req.data instanceof FormData) {
        delete req.headers['Content-Type'];
    }
    return req;
  },
  (error) => {
    // console.error('Request error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor to handle responses and errors
TXN_API.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      // Server responded with a status other than 2xx
      if (error.response.status === 401) {
        // console.error('Unauthorized access - possibly due to expired token');
      } else {
        const responseErrors = error?.response?.data?.errors;
        const fallbackMessage = error?.response?.data?.message || "An error occurred";
        if (responseErrors) {
          // console.error('Response errors:', responseErrors);
        } else {
          // console.error('Response error:', fallbackMessage);
        }
      }
    } else if (error.request) {
      // Request was made but no response received
      // console.error('No response received:', error.request);
    } else {
      // Something else caused the error
      // console.error('Error:', error.message);
    }
    return Promise.reject(error);
  }
);

export const getPaymentGateways = () => TXN_API.get('/wallet/funding-providers');

export const initiateFunding = (credentials) => TXN_API.post('wallet/funding/initialize', credentials);
export const verifyTransaction = (credentials) => TXN_API.post('wallet/funding/verify', credentials);

export const currencyConversionPair = () => TXN_API.get('/currency-exchange/rates');

export const swapCurrencyPreview = (credentials) => TXN_API.post('/currency-exchange/exchange', credentials);
export const swapCurrency = (credentials) => TXN_API.post('/currency-exchange/perform-exchange', credentials);

export const getRecipientDetails = (credential) => TXN_API.get(`/send-money/recipients/search?query=${encodeURIComponent(credential)}`);
export const getRecentRecipients = () => TXN_API.get(`/send-money/recipients/recent`);

export const validateTransfer = (credential) => TXN_API.post(`/send-money/validate`, credential);
export const sendMoney = (credential) => TXN_API.post(`/send-money/create`, credential);
export const bankMoneyTransfer = (credential) => TXN_API.post(`/bank-transfer/initialize`, credential);

export const getBanksByCurrency = (currencyCode, transferMethod) => TXN_API.get(`/bank-transfer/banks/${currencyCode}?institution_type=${transferMethod || 'bank'}`);
export const verifyBankAccount = (credentials) => TXN_API.post('/bank-transfer/verify-bank-account', credentials);
export const verifyBankTransfer = (credentials) => TXN_API.post('/bank-transfer/verify-transfer', credentials);

export const fetchSingleTransactions = (params) => TXN_API.get(`/transaction/${params}`);
export const fetchTransactions = (itemsPerPage, pageNumber, startDate, endDate) => {
  // const query = new URLSearchParams();

  // if (startDate || endDate) {
  //   if (startDate) query.append('created_at[min]', startDate);
  //   if (endDate) query.append('created_at[max]', endDate);
  // } else {
  //   query.append('paginate[per_page]', itemsPerPage);
  //   query.append('paginate[current_page]', pageNumber);
  // }

  const query = new URLSearchParams({
    'paginate[per_page]': itemsPerPage,
    'paginate[current_page]': pageNumber,
  });

  if (startDate) query.append('created_at[min]', startDate);
  if (endDate) query.append('created_at[max]', endDate);

  return TXN_API.get(`/transaction?${query}`);
};



export default TXN_API;